<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wqF4Hd/tc-custom/9798886933383.jpg?1726444269451" alt="This image is the cover for the book The Magic Words"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Magic Words
      </h1>
      <p class="bookDescription body article font2">
        <p>Hogarth is a nice little boy who lives in Rottenberg, the nastiest town around. He smiles often, is courteous and uses the ‘magic words,’ like ‘please,’ ‘thank you,’ ‘I am sorry,’ and ‘excuse me’ all of the time. No one else does in his town and they are always nasty and grumpy. His parents are worried their neighbors will wonder what sort of child they are raising because he is so happy! One day, Hogarth is given a piece of candy that tastes wonderful and never gets smaller no matter how much he licks it. The magical candy ends up teaching all of the mean people in Rottenberg why being courteous and using the magic words is so important and helpful to everyone’s lives, even theirs!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Link Hoewing, Garth von Ahnen
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:16px;font-family:"Arial",sans-serif;color:black;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>Link Hoewing is a retired legislative staffer in the U. S. Congress, and technology executive and the father of three daughters. He has six grandchildren and has always loved writing and telling stories. One of his greatest joys is reading to his grandchildren and making them laugh. This story uses humor to make its point and is based on elements of bedtime fairy tales he made up for his daughters when they were little girls.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c1769ade